import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './LandlordCertificate.module.scss';

export const LandlordCertificate = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/landlord-certificate/Landlord Certificates.webp"
        imageAlt="Landlord Safety Expert examining property"
        title="Landlord Certifications"
      />

      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={styles.inner_section}>
                <TitleAndDescComponent
                  styles={styles}
                  title="Landlord Certificate Services in London"
                  description="Get your landlord certificates with ease. Our expert team makes sure your property meets legal requirements efficiently and reliably."
                />

                <CTAButton
                  title="Book Online"
                  serviceName="Landlord Certificates"
                />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle="Landlord Certifications"
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/landlord-certificate/EICR.jpeg"
                      imgAlt="Electrical Installation Condition Report (EICR)"
                      title="Electrical Installation Condition Report (EICR)"
                      description="An Electrical Installation Condition Report (EICR) is a key safety document that ensures your electrical system is compliant with Wiring Regulations BS 7671. Our qualified electricians conduct thorough inspections and testing of your electrical installations to identify faults, deterioration, or any safety risks. This report is essential for homeowners, landlords, and businesses to verify electrical safety, particularly for rental properties where regular inspections are legally required. The EICR will include findings & recommendations for remedial work to maintain compliance with safety standards."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/landlord-certificate/PAT-testing.jpeg"
                      imgAlt="Portable Appliance Testing (PAT)"
                      title="Portable Appliance Testing (PAT)"
                      description="PAT testing is widely used by homeowners, businesses, and landlords to maintain compliance with safety regulations. It minimises the risk of electric shocks or fires and ensures adherence to the Electricity at Work Regulations 1989. This electrical testing involves a visual inspection and manual checks using portable appliance testers. We provide PAT testing services across London. Our electricians are equipped to test all appliances and can schedule the work at your convenience. Whether you're a homeowner or landlord, we are here to assist you."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/landlord-certificate/Energy Performance.webp"
                      imgAlt="Energy Performance rating graphic"
                      title="Energy Performance Certificate (EPC)"
                      description="An Energy Performance Certificate (EPC) is required when renting out your property. Our EPC service evaluates your property's energy efficiency and provides a detailed report that helps you understand how to improve energy use. This certificate is essential for complying with rental regulations and making your property more attractive to prospective tenants. By identifying key areas for improvement, you can enhance your property’s sustainability and reduce energy costs. Plus, a higher EPC rating can increase the overall value of your property, appealing to environmentally-conscious renters."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.root}>
        <EmergencyComponent
          title="Landlord Safety Services"
          imageSrc="/images/services/landlord-certificate/Landlord Safety Services.webp"
          imageAlt="Landlord Safety Expert examining circuit breaker"
          styles={styles}
          para1="Staying compliant with landlord certification requirements is essential to keeping your property safe and your tenants protected. Our services make it easy for London-based landlords to obtain the necessary certifications, including gas safety and electrical certificates."
          para2="Our experienced team guarantees quick and hassle-free compliance. We take care of full compliance with all legal requirements, giving you confidence that your property is secure and ready for tenants."
        />
        <ListOfServices
          styles={styles}
          serrviceList={[
            { name: 'Gas Safety Certificate' },
            { name: 'Fire Risk Assessment' },
            { name: 'Electrical Installation Condition Report (EICR)' },
            { name: 'Portable Appliance Testing (PAT)' },
            { name: 'Energy Performance Certificate (EPC)' },
          ]}
        />
        <AreasWeCover styles={styles} />
        <PostCodes
          styles={styles}
          mainPageUrl="/services/landlord-certificate"
        />
        <FAQsView title="FAQs" faqItems={faqItems} />
      </div>
    </>
  );
};
// {name: ""},

const faqItems = [
  {
    title: 'How often should safety inspections be done for rental properties?',
    details: `Gas safety inspections must be carried out annually, while electrical safety inspections are recommended every five years to ensure everything remains in safe working order.`,
  },
  {
    title: 'What landlord safety services do you provide?',
    details:
      'We provide a range of services for landlord safety, including gas, fire, and electrical inspections, as well as any necessary repairs and certifications to keep your property compliant.',
  },
  {
    title: 'Do you offer certifications for rental properties in London?',
    details: `Yes, we offer all required certifications for rental properties, including gas, fire, and electrical safety certificates, ensuring full compliance with UK regulations.`,
  },
  {
    title: 'How long does an inspection usually take?',
    details: `The duration of a safety inspection depends on the property size and the number of appliances. Typically, gas safety inspections take 2-3 hours, while electrical safety inspections take around 3-4 hours.`,
  },
  {
    title: 'What if a safety issue is found during the inspection?',
    details: `If a safety issue is identified, we will notify the property owner and provide recommendations for any necessary repairs or upgrades to address the problem.`,
  },
];
